import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import MeterInformationAccordion from '@/containers/SubscriptionFormPageNew/Components/shared/Meter/MeterInformationAccordion'

const MeterCompleteInformation = ({ currentValue, type }) => {
  const { t } = useTranslation()
  const panels = []
  const panelsBasic = []
  const gasMeterDetails = currentValue?.gas ?? null
  // Consumption
  if (
    gasMeterDetails &&
    typeof gasMeterDetails.yearlyExtrapolation !== 'undefined' &&
    gasMeterDetails.yearlyExtrapolation !== null &&
    type === 'client'
  ) {
    const text = []

    text.push({
      text: '',
      value: `${gasMeterDetails.yearlyExtrapolation} kWh`,
    })

    panels.push({
      title: t('subscriptionForm:pce_module.meter_complete_information.consumption_title'),
      text: text.length > 0 ? text : [t('subscriptionForm:pce_module.meter_complete_information.no_info_available')],
    })
  }

  // Basic information
  if (
    gasMeterDetails &&
    (gasMeterDetails?.deliveryPoint?.state ||
      gasMeterDetails?.deliveryPoint?.deliveryStatus ||
      gasMeterDetails?.deliveryPoint?.meterType ||
      gasMeterDetails?.deliveryPoint?.readingFrequency ||
      gasMeterDetails?.deliveryPoint?.gridRate)
  ) {
    const state = gasMeterDetails?.deliveryPoint?.state
    const deliveryStatus = gasMeterDetails?.deliveryPoint?.deliveryStatus
    const meterType = gasMeterDetails?.deliveryPoint?.meterType
    const readingFrequency = gasMeterDetails?.deliveryPoint?.readingFrequency
    const gridRate = gasMeterDetails?.deliveryPoint?.gridRate
    const text = []

    if (state) {
      text.push({
        text: t('subscriptionForm:pce_module.meter_complete_information.basic_information.state'),
        value: t('subscriptionForm:pce_module.meter_complete_information.basic_information.' + state),
      })
    }

    if (deliveryStatus) {
      text.push({
        text: t('subscriptionForm:pce_module.meter_complete_information.basic_information.delivery_status'),
        value: deliveryStatus,
      })
    }

    if (meterType) {
      text.push({
        text: t('subscriptionForm:pce_module.meter_complete_information.basic_information.meter_type'),
        value: meterType,
      })
    }

    if (readingFrequency) {
      text.push({
        text: t('subscriptionForm:pce_module.meter_complete_information.basic_information.reading_frequency'),
        value: readingFrequency,
      })
    }

    if (gridRate) {
      text.push({
        text: t('subscriptionForm:pce_module.meter_complete_information.basic_information.grid_rate'),
        value: gridRate,
      })
    }

    panelsBasic.push({
      title: t('subscriptionForm:pce_module.meter_complete_information.basic_information.title'),
      text: text.length > 0 ? text : [t('subscriptionForm:pce_module.meter_complete_information.no_info_available')],
    })
  }

  // AddressSearch information
  if (gasMeterDetails && gasMeterDetails?.deliveryPoint?.address && type === 'client') {
    const address = gasMeterDetails?.deliveryPoint?.address
    const text = []

    if (address.street) {
      const streetNumber = address.number ? address.number + ' ' : ''
      text.push({
        text: '',
        value: streetNumber + address.street,
      })
    }

    if (address.townName) {
      text.push({
        text: '',
        value: `${address.postalCode ?? ''} ${address.townName}`,
      })
    }

    panelsBasic.push({
      title: t('subscriptionForm:pce_module.meter_complete_information.address.address'),
      text: text.length > 0 ? text : [t('subscriptionForm:pce_module.meter_complete_information.no_info_available')],
    })
  }

  return <MeterInformationAccordion mainPanels={panelsBasic} panels={panels} />
}

MeterCompleteInformation.propTypes = {
  currentValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  type: PropTypes.string,
}

export default MeterCompleteInformation
